import React from 'react';

export default function SVGDocument(): JSX.Element {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      className="text-iconStrong stroke-current"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SVG_DOCUMENT"
    >
      <rect x="1.152" y="1.332" width="21.4" height="15" rx="1.44" />
      <path d="M8.953 8.832a2.7 2.7 0 11-5.4 0 2.7 2.7 0 015.4 0z" />
      <path d="M11.852 6.432h8M11.852 8.832h8M11.852 11.232h8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

SVGDocument.defaultProps = {
  color: '#33B236',
};
